// EMV BR Code (Pix "copia e cola") generator - no dependencies
// Based on Bacen manual: ID + length (2 digits) + value

function tlv(id, value) {
  const len = value.length.toString().padStart(2, '0');
  return `${id}${len}${value}`;
}

function crc16(payload) {
  let crc = 0xFFFF;
  for (let i = 0; i < payload.length; i++) {
    crc ^= payload.charCodeAt(i) << 8;
    for (let j = 0; j < 8; j++) {
      if (crc & 0x8000) crc = ((crc << 1) ^ 0x1021) & 0xFFFF;
      else crc = (crc << 1) & 0xFFFF;
    }
  }
  return crc.toString(16).toUpperCase().padStart(4, '0');
}

function sanitize(str, max) {
  const out = (str || '')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^A-Za-z0-9 ]/g, '')
    .toUpperCase();
  return out.slice(0, max);
}

export function buildPixPayload({ key, amount, merchantName, merchantCity, txid = '***', description = '' }) {
  const gui = tlv('00', 'br.gov.bcb.pix');
  const keyTlv = tlv('01', key);
  const descTlv = description ? tlv('02', description.slice(0, 40)) : '';
  const merchantAccount = tlv('26', gui + keyTlv + descTlv);

  const payloadFormat = tlv('00', '01');
  const merchantCategory = tlv('52', '0000');
  const currency = tlv('53', '986');
  const amt = amount && Number(amount) > 0 ? tlv('54', Number(amount).toFixed(2)) : '';
  const country = tlv('58', 'BR');
  const name = tlv('59', sanitize(merchantName, 25) || 'RECEBEDOR');
  const city = tlv('60', sanitize(merchantCity, 15) || 'SAO PAULO');
  const addData = tlv('62', tlv('05', (txid || '***').replace(/[^A-Za-z0-9]/g, '').slice(0, 25) || '***'));

  const partial = payloadFormat + merchantAccount + merchantCategory + currency + amt + country + name + city + addData + '6304';
  const crc = crc16(partial);
  return partial + crc;
}
